module.exports = __webpack_public_path__ + "img/dota2.7d35226d.png";